import React, { useState, useEffect } from 'react';
import { Button, Form, Alert } from 'react-bootstrap';
import toastr from 'toastr';
import 'toastr/build/toastr.min.css';
import StyledModal from '../Components/StyledModal';

const SaveReportModal = ({ show: initialShow, onHide, filters, includes, onSaveSuccess }) => {
  const [isOpen, setIsOpen] = useState(initialShow);
  const [reportName, setReportName] = useState('');
  const [isSaving, setIsSaving] = useState(false);
  const [error, setError] = useState('');
  console.log(includes);
  console.log(filters);
  useEffect(() => {
    setIsOpen(initialShow);
  }, [initialShow]);

  const handleSave = async () => {
    if (!reportName.trim()) {
      setError('Please enter a name for your report');
      return;
    }

    setIsSaving(true);
    setError('');

    try {
      if (onSaveSuccess) {
        onSaveSuccess(reportName, filters, includes);
      }

      // toastr.success('Saved. Find it in the saved reports list on the right'); <-- loading into Quick Reports card now
      setReportName('');
    } catch (err) {
      console.error('Error saving report:', err);
      setError('Failed to save report. Please try again.');
    } finally {
      setIsSaving(false);
      setIsOpen(false);
    }
  };

  const handleClose = () => {
    setReportName('');
    setError('');
    setIsOpen(false);
    if (onHide) onHide();
  };

  return (
    <StyledModal
      size="md"
      direction="right"
      title="Save Report Builder"
      footerCloseButton={true}
      footerButtons={
        <Button variant="primary" onClick={handleSave} disabled={isSaving}>
          <i className="fal fa-save me-1"></i> Save
        </Button>
      }
      onClose={(e) => handleClose()}
      show={isOpen}
    >
      {isSaving && (
        <p className="alert alert-info small mt-3">
          Loading... <i className="fas fa-spinner fa-spin"></i>
        </p>
      )}
      <Alert variant="info" className="small">
        Enter a memorable name for this report filter combination. You will be able to quickly pull
        up records with these filter combos by clicking &quot;Saved Filters&quot; in the right hand
        corner of the &quot;Report Builder&quot; section.
      </Alert>

      <Form.Group className="mb-3">
        <Form.Label>Memorable name</Form.Label>
        <Form.Control
          type="text"
          value={reportName}
          onChange={(e) => {
            setReportName(e.target.value);
            setError('');
          }}
          isInvalid={!!error}
          autoComplete="off"
          className="form-control-sm"
        />
        <Form.Control.Feedback type="invalid">{error}</Form.Control.Feedback>
      </Form.Group>
    </StyledModal>
  );
};

export default SaveReportModal;
